<template>
  <v-dialog v-model="modelValue" content-class="rounded-lg" :max-width="maxWidth">
    <v-sheet color="white" class="rounded-lg d-flex flex-column pa-4 gap-4">
      <div class="d-flex flex-row justify-space-between align-center gap-4">
        <slot name="title">
          <span class="font-size-20">
            {{ title }}
          </span>
        </slot>
        <v-btn icon dense class="font-size" color="gray" @click="modelValue = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <slot />
    </v-sheet>
  </v-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'

export default {
  name: 'InfoDialogComponent',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    maxWidth: {
      type: [Number, String],
      default: 960,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped></style>
